module.exports = __webpack_public_path__ + "img/rbtech-logo.9bffe539.jpg";